import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {UrlPrefix} from "../common/constants/url-prefix.constants";

@Injectable()
export class CpqSystemIdService {

  constructor(private http: HttpClient) { }

  public getSystemId(url: string, name: string): Observable<string> {
    return this.http.get<string>(`${UrlPrefix.OLD_SETUP_API_PREFIX}/${url}?name=${encodeURIComponent(name)}`);
  }

  public getSystemIdStandardApi(url, name, apiParameter = "name"): Observable<string> {
    return this.http.get<string>(`${url}?${apiParameter}=${encodeURIComponent(name)}`);
  }
}
